<template>
    <div class="steps tw-relative lg:tw-static lg:tw-top-0 tw-top-8 tw-flex lg:tw-flex-row tw-flex-col lg:tw-items-start tw-items-center tw-justify-between tw-w-full tw-max-w-[64rem] tw-mx-auto">
        <Step
                v-for="(step, index) in steps"
                :key="index"
                :circle-content="step.circleContent"
                :title="step.title"
                :description="step.description"
                :circle-dashed-line="step.circleDashedLine"
                :circle-color="step.circleColor"
        />
    </div>
</template>

<script>
import Step from "./Step.vue";

export default {
    name: 'Steps',
    components: {
        Step,
    },
    mixins: [],
    props: {
        steps: {
            type: Array,
            required: true,
            validator(steps) {
                return steps.every(
                    (step) => typeof step === 'object'
                );
            }
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>
